<script setup lang="ts">
import { useTeamStore } from '@/store/teamStore'
import { RegisterModal, TrialModal } from './parts'
const teamStore = useTeamStore()
const emits = defineEmits<{
  (e: 'close'): void
  (e: 'compare'): void
}>()
</script>

<template>
  <div>
    <RegisterModal v-if="teamStore.belongsToTeam" @close="emits('close')">
      <template #description>
        <slot name="description" />
        <a @click="emits('compare')">プランを比較する</a>
      </template>
    </RegisterModal>
    <TrialModal v-else @close="emits('close')">
      <template #description>
        <slot name="description" />
        <a @click="emits('compare')">プランを比較する</a>
      </template>
    </TrialModal>
  </div>
</template>

<style scoped>
/* css */
</style>
